<template>
  <div class="patrol-container">
    <div class="panel-left">
      <div class="plan-list-panel">
        <div class="plan-list" :class="showLeftPanel ? 'plan-list-show' : ''">
          <div class="planSearch">
            <el-input
              style="width: 75%; height: 40px"
              v-model="searchPlanName"
              @keyup.enter.native="queryListData"
              clearable
              @clear="queryListData"
              placeholder="请输入计划名称"
            >
            </el-input>
            <span style="height: 20px"> | </span>
            <img
              src="@src/common/assets/images/search.png"
              alt=""
              @click="queryListData"
            />
          </div>
          <div
            class="box-card"
            v-loading="dataLoading"
            element-loading-text="数据加载中"
            element-loading-spinner="el-icon-loading"
          >
            <el-scrollbar class="scroll-content" ref="refScrollbar" style="height: 100%">
              <div
                v-for="item in tableData"
                :key="item.planCode"
                :class="
                  activePlanInfo && item.planCode == activePlanInfo.planCode
                    ? 'active'
                    : ''
                "
                class="text item map-blur-panel__list-item"
                @click.prevent="showDetail(item)"
              >
                <span class="flex-p4">
                  <el-tooltip placement="top-start" :content="item.planName">
                    <div class="plan-list-tab">
                      <span slot="content">{{ item.planName }}</span>
                    </div>
                  </el-tooltip>
                  <el-tooltip
                    v-if="item.status == 2"
                    effect="dark"
                    content="启动"
                    placement="top-start"
                    :visible-arrow="false"
                  >
                    <span
                      class="icon iconfont icon-qiyong"
                      @click.stop="changeStatus('1', item)"
                    ></span>
                  </el-tooltip>
                  <el-tooltip
                    v-if="item.status == 1"
                    effect="dark"
                    :content="$t('videoPatrol.button.stop')"
                    placement="top-start"
                    :visible-arrow="false"
                  >
                    <span
                      class="icon iconfont icon-jinyong1"
                      @click.stop="changeStatus('2', item)"
                    ></span>
                  </el-tooltip>
                  <el-tooltip
                    effect="dark"
                    content="编辑"
                    placement="top-start"
                    :visible-arrow="false"
                  >
                    <span
                      style="margin: 0 16px"
                      class="icon iconfont icon-xiugai"
                      @click.stop="handleEdit(item)"
                    ></span>
                  </el-tooltip>
                  <el-tooltip
                    effect="dark"
                    content="删除"
                    placement="top-start"
                    :visible-arrow="false"
                  >
                    <span
                      class="icon iconfont icon-shanchu"
                      @click.stop="handleDel(item)"
                    ></span>
                  </el-tooltip>
                </span>
                <div class="list-operator">
                  <div class="list-item">
                    <span class="list-label"
                      >监控点: {{ item.cameraList.length }} 个</span
                    >
                    <span> 状态：{{ item.status == 1 ? "启用" : "停用" }} </span>
                  </div>
                </div>
                <div class="list-operator">
                  <div class="list-item">
                    <span
                      >巡逻日期：
                      {{ item.startDate }}
                      ~ {{ item.endDate }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="no-data-text" v-if="tableData.length == 0">
                <div>
                  <img src="@/common/assets/images/empty.svg" class="no-data_img" />
                </div>
                <div>暂无数据</div>
              </div>
            </el-scrollbar>
          </div>
          <!-- <el-row class="data-pagination map-blur-panel__title">
            <el-pagination
              small
              layout="total, prev, pager, next"
              :page-size="page.pageSize"
              :total="page.total"
              :current-page="page.pageNo"
              :pager-count="5"
              @current-change="pageChange"
              @prev-click="pageChange"
              @next-click="pageChange"
            ></el-pagination>
          </el-row> -->
          <!-- v-if="showAddBtn" -->
          <div class="plan-list-toolbar">
            <div class="addbtn">
              <el-button type="primary" @click="addPlan"> 创建巡逻计划 </el-button>
            </div>
            <div
              class="map-blur-panel__expand-button left iconfont-lunan"
              :class="
                showLeftPanel
                  ? 'icon-lunan-shousuocaidan'
                  : 'icon-lunan-shousuocaidan-copy'
              "
              @click="showPlanListPanel"
            ></div>
          </div>
        </div>
      </div>
    </div>
    <!-- v-if="showRight" -->
    <div class="panel-right">
      <patrol-right
        ref="planInfoPanel"
        :showPanel="showRight"
        :panelType="panelType"
        @toggleDevice="toggleDevice"
        @asc="asc"
        @desc="desc"
        :selectedDeviceInfo="selectedDeviceInfo"
        @handleCancelPanel="handleCancelPanel"
      >
      </patrol-right>
    </div>
  </div>
</template>

<script>
import { api } from "../api.js";
import mixinMap from "@src/components/common/gis/mixinMap.js";
import { Dates } from "$utils";
// import utils from "@src/common/utils";
// import CalendarComponent from "../components/calendar-component";
import patrolRight from "../components/patrol-right";
// import appPanel from "@src/components/business/app-panel/index.vue";
export default {
  mixins: [mixinMap],

  components: {
    // appPanel,
    patrolRight,
    // CalendarComponent,
  },
  data() {
    return {
      activePlanInfo: null, //当前点击的计划详情
      showLeftPanel: false,
      searchPlanName: "",
      searchParams: {},
      showAddBtn: true,
      isTransparent: true,
      tableData: [],
      showRight: false,
      options: {
        index: true,
        maxHeight: "100%",
        emptyText: "暂无数据",
        column: [
          { prop: "planName", label: "巡逻计划名称" },
          { prop: "status", label: "状态", formslot: true },
        ],
      },
      formData: {
        planName: "",
        planDate: {
          // 时间段类型，1-全天时段；2-自定义时段
          // 默认选中自定义时段
          rangType: 2,
          startDate: "",
          endDate: "",
          plannedPlayTime: [],
        },
      },
      numList: [1, 4, 9, 16],
      roundStatus: [
        { label: "是", value: 1 },
        { label: "否", value: 0 },
      ],
      rules: {
        planName: [{ required: true, message: "请输入计划名称", trigger: "blur" }],
        windowNum: [{ required: true, message: "请输入窗口数量", trigger: "blur" }],
        signTime: [{ required: true, message: "请输入打卡次数", trigger: "blur" }],
        weatherToPoll: [{ required: true, message: "请选择", trigger: "blur" }],
        planDate: [{ required: true, message: "请选择巡逻时间", trigger: "blur" }],
      },
      page: {
        pageNo: 1,
        pageSize: 30,
      },

      devicesId: [], //摄像机ID集合
      devices: [],
      selectedDeviceId: [],
      selectedDeviceInfo: [],
      trajectory: [], //轨迹点
      rightTitle: "",
      editType: "",
      showHandle: true,
      showModal: false,
      cameraPointId: "cameraPointId",
      panelType: 0, //0新增 1修改 2 详情
      boxScrollContainer: "",
      scrollView: "",
      dataLoading: false,
    };
  },
  beforeDestroy() {
    this.$map.hideMap2D();
  },
  created() {},
  mounted() {
    this.$map.showMap2D(this.mapInit);
    this.scrollbar();
    this.getPlanList();
    this.showLeftPanel = true;
    // this.showPlanListPanel();
  },

  methods: {
    // 列表滚动
    scrollbar() {
      let list = this.$refs.refScrollbar;
      this.boxScrollContainer = list.$el.querySelector(".el-scrollbar__wrap");
      this.scrollView = this.boxScrollContainer.querySelector(".el-scrollbar__view");
      this.scrollFun = (e) => {
        if (
          e.srcElement.scrollTop + this.boxScrollContainer.clientHeight >=
            this.scrollView.clientHeight &&
          !this.dataLoading &&
          this.tableData.length % 30 === 0 &&
          this.tableData.length !== 0
        ) {
          this.page.pageNo = this.page.pageNo + 1;
          this.getPlanList();
        }
      };
      this.boxScrollContainer.addEventListener("scroll", this.scrollFun);
    },

    //新增巡逻计划
    addPlan() {
      if (this.showRight) {
        this.$refs.planInfoPanel.closeRight();
        setTimeout(() => {
          this.addPlan();
        }, 300);
        return;
      }
      this.panelType = 0;
      this.formData = {
        planName: "",
        planDate: {
          // 时间段类型，1-全天时段；2-自定义时段
          // 默认选中自定义时段
          rangType: 2,
          startDate: "",
          endDate: "",
          plannedPlayTime: [],
        },
      };
      this.selectedDeviceId = [];
      this.selectedDeviceInfo = [];
      this.showRight = true;
      this.showAddBtn = false;
      this.$nextTick(() => {
        this.$refs.planInfoPanel.open();
      });
    },
    chooseDate() {
      this.$nextTick(() => {
        if (this.rightTitle == "详情") return;
        this.$refs.calendarComp.show(this.formData.planDate, this.editType === 3);
      });
    },
    confirmCalendar(data) {
      this.formData.planDate = data;
      this.$forceUpdate();
    },
    // 收起左侧面板
    showPlanListPanel() {
      this.showLeftPanel = !this.showLeftPanel;
    },
    mapInit() {
      this.queryDevicesByAreas();
    },
    // 图标点击事件
    handleMapClick(e, b) {
      if (this.showRight && this.panelType != 2) {
        // 编辑状态下走选中效果
        this.toggleDevice(e.marker, true);
      } else {
        // 详情状态下显示弹窗
        this.$map.MapInstance2D.handleCameraMapClick(e);
        return;
      }
    },
    toggleDevice(item, isMapEdit = false) {
      let id, choosedIndex;
      if (item.id.indexOf(this.cameraPointId) > -1) {
        id = item.id;
        choosedIndex = this.selectedDeviceId.indexOf(
          id.replace(this.cameraPointId + "-", "")
        );
      } else {
        choosedIndex = this.selectedDeviceId.indexOf(item.id);
        id = this.cameraPointId + "-" + item.id;
      }
      if (choosedIndex === -1) {
        // 添加
        // camera_controlled_3
        let point = this.getMapPoint(item, "_controlled");
        this.$map.MapInstance2D.updateFeatureById(this.cameraPointId, id, {
          src: point.src,
        });
        this.selectedDeviceId.push(item.attr ? item.attr.id : item.id);
        let obj = {};
        if (isMapEdit) {
          let target = { name: item.attr.name };
          obj = Object.assign(target, item);
        } else {
          obj = item;
        }
        this.selectedDeviceInfo.push(obj);
      } else {
        // 取消
        let point = this.getMapPoint(item);
        this.$map.MapInstance2D.updateFeatureById(this.cameraPointId, id, {
          src: point.src,
        });
        this.selectedDeviceId.splice(choosedIndex, 1);
        this.selectedDeviceInfo.splice(choosedIndex, 1);
      }
      this.selectedDeviceInfo = this.selectedDeviceInfo.map((item) => {
        let id = "";
        // let itemId = item.id;
        if (item.id) {
          id =
            item.id.indexOf(this.cameraPointId) > -1
              ? item.id.replace(this.cameraPointId + "-", "")
              : item.id;
        }
        // console.log(item, "====item");
        return {
          cameraID: id ? id : item.cameraID,
          cameraName: item.attr ? item.attr.cameraName : item.cameraName,
          area: item.attr ? item.attr.area : item.area,
          latitude: item.attr ? item.attr.latitude : item.latitude,
          longitude: item.attr ? item.attr.longitude : item.longitude,
        };
      });
      // this.$forceUpdate();
    },
    getMapPoint(item = {}, type = "") {
      let azimuth = item.azimuth || item.attr?.azimuth || 5;
      return {
        id: item.id,
        coord: [Number(item.longitude), Number(item.latitude)],
        longitude: item.longitude,
        latitude: item.longitude,
        anchor: [10, 12],
        scale: 1,
        src: `images/theme/newDark/map/camera${type}_${azimuth}.png`,
        attr: {
          name: item.name,
          id: item.id,
          // type: item.type,
        },
        name: item.name,
        tipsTitle: "摄像机设备详情",
        showTips: true,
        tipsMap: {
          deviceName: "设备名称",
        },
      };
    },
    //根据区域查询设备
    queryDevicesByAreas() {
      this.devices = [];
      this.$fetch(api.videoTask.queryDeviceList, {
        areas: [],
        deviceType: "18",
      }).then((res) => {
        if (res.success) {
          let cameraList = res.returnObj;
          for (let item of cameraList) {
            // 只渲染室外摄像机
            if (
              item.longitude &&
              item.latitude &&
              item.longitude > 0 &&
              item.latitude > 0 &&
              item.isIndoor == 0
            ) {
              let azimuth = item.azimuth || 5;
              this.devicesId.push(item.thirdDeviceId);
              let longitude = item.longitude.slice(0, 10);
              let latitude = item.latitude.slice(0, 10);
              let coord = [Number(longitude), Number(latitude)];
              this.devices.push({
                id: item.thirdDeviceId,
                tipsTitle: "摄像机详情",
                showTips: true,
                tipsMap: {
                  deviceName: "摄像机名称",
                  areaName: "所属区域",
                  statusName: "状态",
                  factoryName: "厂家",
                  createrTime: "创建时间",
                },
                name: item.thirdDeviceName,
                coord: [...coord],
                anchor: [10, 12],
                azimuth: azimuth,
                scale: 1,
                attr: {
                  ...item,
                  cameraName: item.thirdDeviceName,
                  id: item.thirdDeviceId,
                  area: item.area,
                },
                src: `images/theme/newDark/map/${
                  item.statusName == "在线"
                    ? "camera_" + azimuth + ".png"
                    : "camera_gray" + azimuth + ".png"
                }`,
              });
            }
          }
          this.getDevices(this.devices);
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    /**
     * 刷新已选择区域的设备，重绘地图
     * @param devices
     */
    getDevices(devices) {
      this.$map.MapInstance2D.addMarket(
        devices,
        this.cameraPointId,
        this.handleMapClick
        // this.toggleDevice
      );
      this.selectedDeviceId = [];
      this.selectedDeviceInfo = [];
    },
    changeStatus(code, data) {
      this.$fetch(api.videoTask.planStatus, {
        planCode: data.planCode,
        planStatus: code,
      }).then((res) => {
        let text = "";
        code == 1 ? (text = "启动") : (text = "停用");
        if (res.success) {
          this.$message.success(text + "成功");
          this.getPlanList();
        } else {
          this.$message.error(res.msgContent + "," + text + "失败");
        }
      });
    },
    desc(index) {
      let current = this.selectedDeviceInfo.splice(index, 1);
      this.selectedDeviceInfo.splice(index + 1, 0, current[0]);

      this.selectedDeviceId.splice(
        index + 1,
        0,
        this.selectedDeviceId.splice(index, 1)[0]
      );
    },
    asc(index) {
      let current = this.selectedDeviceInfo.splice(index, 1);
      this.selectedDeviceInfo.splice(index - 1, 0, current[0]);
      this.selectedDeviceId.splice(
        index - 1,
        0,
        this.selectedDeviceId.splice(index, 1)[0]
      );
    },
    queryStatusAndDetail(row, type) {
      this.activePlanInfo = { ...row };
      // this.mapInit();
      this.$fetch(api.videoTask.planTaskStatus, {
        planCode: row.planCode,
      }).then((res) => {
        if (
          res.success &&
          res.returnObj &&
          res.returnObj.taskStatus == 2 &&
          type == "edit"
        ) {
          this.$message.warning(this.$t("videoPatrol.message.disabledModify"));
          return;
        } else {
          this.showAddBtn = false;
          this.showRight = true;
          //  this.getDevices(this.devices);
          // 查询详情
          this.$fetch(api.videoTask.detailPlan, {
            planCode: row.planCode,
          }).then((response) => {
            if (response.success) {
              this.selectedDeviceInfo = [];
              this.selectedDeviceId = [];
              let trajectoryData = [];
              this.$nextTick(() => {
                this.$refs.planInfoPanel.open(response.returnObj);
              });
              let coord = [
                +response.returnObj.cameraList[0].longitude,
                +response.returnObj.cameraList[0].latitude,
              ];
              // console.log(coord, "=====coord");
              this.$map.MapInstance2D.setMapCenter(coord);
              response.returnObj.cameraList.forEach((item) => {
                // console.log(item);
                // 已选摄像机数据
                // this.selectedDeviceId.push(item.cameraID);
                let azimuth = item.azimuth || 5;
                let obj = {
                  id: item.cameraID,
                  cameraName: item.cameraName,
                  coord: [
                    item.longitude !== null ? Number(item.longitude.slice(0, 10)) : "无",
                    item.latitude !== null ? Number(item.latitude.slice(0, 10)) : "",
                  ],
                  longitude:
                    item.longitude !== null ? Number(item.longitude.slice(0, 10)) : "无",
                  latitude:
                    item.latitude !== null ? Number(item.latitude.slice(0, 10)) : "",
                  attr: {
                    cameraName: item.cameraName,
                    cameraSort: item.cameraSort,
                    startPresetPosition: item.startPresetPosition,
                    endPresetPosition: item.endPresetPosition,
                    playDuration: item.playDuration,
                    area: item.area,
                    id: item.cameraID,
                    azimuth: item.azimuth,
                  },
                  // src: "images/theme/newDark/map/camera-Active.png",
                  src: `images/theme/newDark/map/camera_controlled_${azimuth}.png`,
                };
                this.toggleDevice(obj);
                this.selectedDeviceInfo.push({
                  id: item.thirdDeviceId,
                  cameraName: item.cameraName,
                  coord: [
                    item.longitude !== null ? Number(item.longitude.slice(0, 10)) : "无",
                    item.latitude !== null ? Number(item.latitude.slice(0, 10)) : "",
                  ],
                  longitude:
                    item.longitude !== null ? Number(item.longitude.slice(0, 10)) : "无",
                  latitude:
                    item.latitude !== null ? Number(item.latitude.slice(0, 10)) : "",
                  attr: {
                    cameraName: item.cameraName,
                    cameraSort: item.cameraSort,
                    startPresetPosition: item.startPresetPosition,
                    endPresetPosition: item.endPresetPosition,
                    playDuration: item.playDuration,
                    area: item.area,
                  },
                  src: "images/theme/newDark/map/camera_selected.png",
                  scale: 0.8,
                });

                //画轨迹数据
                // trajectoryData.push({
                //   point: (() => {
                //     let ary = [];
                //     ary.push(item.longitude);
                //     ary.push(item.latitude);
                //     ary.push(`./images/theme/dark/map/camera_red.png`);
                //     ary.push(item);
                //     return ary;
                //   })(item),
                //   id: item.cameraID,
                // });
                // 清除已选点的初始打点
                // this.$map.MapInstance2D.removePoint(item.cameraID);
              });
              // this.$map.MapInstance2D.setMapCenter(trajectoryData[0].point);
              // this.$map.MapInstance2D.drawTrajectory(trajectoryData, 1.222);
              this.$log.debug("打开修改--已选设备点位信息：", this.selectedDeviceInfo);
              this.showRight = true;
              this.formData = response.returnObj;
              this.selectedDeviceInfo = this.formData.cameraList;
              this.formData.planDate = {
                rangType: response.returnObj.isAllTime,
                plannedPlayTime: response.returnObj.plannedPlayTime,
                startDate: this.$utils.getDateStr(
                  response.returnObj.startDate,
                  "YYYY-MM-DD"
                ),
                endDate: this.$utils.getDateStr(response.returnObj.endDate, "YYYY-MM-DD"),
              };
              // this.formData.planDate.startDate = response.returnObj.startDate;
              // this.formData.planDate.endDate = this.$utils.getDateStr(
              //   response.returnObj.endDate,
              //   "YYYY-MM-DD"
              // );

              // setTimeout(() => {
              //   this.$refs.patrolAdd.edit(response.returnObj, 2);
              // }, 500);
            } else {
              this.$message.error(response.msgContent);
            }
          });
        }
      });
    },
    //点击查询详情
    showDetail(row) {
      if (this.showRight) {
        this.$refs.planInfoPanel.closeRight();
        setTimeout(() => {
          this.showDetail(row);
        }, 300);
        return;
      }
      this.panelType = 2;
      // this.showRight = false;
      this.queryStatusAndDetail(row);
    },
    handleEdit(row) {
      if (this.showRight) {
        this.$refs.planInfoPanel.closeRight();
        setTimeout(() => {
          this.handleEdit(row);
        }, 300);
        return;
      }
      this.panelType = 1;
      // this.showRight = false;
      this.queryStatusAndDetail(row, "edit");
    },
    //删除
    handleDel(row) {
      this.$confirm(
        this.$t("videoPatrol.message.modifyPlans"),
        this.$t("videoPatrol.button.prompt"),
        {
          confirmButtonText: this.$t("videoPatrol.button.conform"),
          cancelButtonText: this.$t("videoPatrol.button.cancel"),
          type: "warning",
        }
      ).then(() => {
        const params = {
          planCode: row.planCode,
        };
        this.$fetch(api.videoTask.deletePlan, params).then((response) => {
          if (response.success) {
            this.getPlanList();
            this.$message.success(response.msgContent);
          } else {
            this.$message.error(response.msgContent);
          }
        });
      });
    },
    queryListData() {
      this.searchParams = this.searchPlanName;
      this.getPlanList();
    },
    pageChange(pageNo) {
      this.page.pageNo = pageNo;
      this.getPlanList();
    },
    //模板列表
    getPlanList(params = {}) {
      this.dataLoading = true;
      // delete this.page.total;
      params.pageNo = this.page.pageNo;
      params.pageSize = this.page.pageSize;
      params.planName = this.searchParams;
      if (this.page.pageNo == 1) {
        this.tableData = [];
      }
      this.$fetch(api.videoTask.listPlan, params).then((res) => {
        if (res.success) {
          this.dataLoading = false;
          let tableData = res.returnObj.list.map((item) => {
            return Object.assign(item, {
              startDate: Dates.format(item.startDate, "yyyy-MM-dd"),
              endDate: Dates.format(item.endDate, "yyyy-MM-dd"),
            });
          });
          this.page.total = res.returnObj.total;
          this.tableData = this.tableData.concat(tableData);
          // this.$forceUpdate();
        }
      });
    },
    //新建/编辑计划点击取消按钮
    handleCancelPanel() {
      let checkList = [...this.selectedDeviceInfo];
      this.panelType = 2;
      this.showAddBtn = true;
      this.showRight = false;
      // this.selectedDeviceInfo = [];
      this.activePlanInfo = null;
      checkList.forEach((item) => {
        this.toggleDevice({
          id: item.cameraID,
          ...item,
        });
      });
      // this.queryDevicesByAreas();
    },
    handleSizeChange(size) {
      this.page.pageSize = size;
      this.getPlanList();
    },
    handleCurrentChange(num) {
      this.page.pageNo = num;
      this.getPlanList();
    },
  },
};
</script>
<style lang="scss">
.planSearch {
  span {
    height: 20px;
  }
  img {
    // width: 16px;
    // height: 16px;
    cursor: pointer;
  }
  .el-input__inner {
    background: #262b37;
    border: none !important;
    margin-top: 4px;
  }
}
</style>
<style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";
@import "../style/planLeft.scss";

.patrol-container {
  .panel-right {
    z-index: 2;
    // width: 400px;
    // right: 0;
    // position: absolute;
    // top: 0;
    //基础信息
    .base-form {
      margin-top: 30px;
    }
    .base-title,
    .point-title {
      padding-left: 10px;
      border-left: 4px solid #4386ff;
    }
    .item-row {
      span {
        padding: 0 20px 0 10px;
      }
    }
    //监控点
    .monitor-point {
      .point_body {
        margin-top: 20px;
        .point_table {
          display: flex;
          line-height: 36px;
          border-bottom: 1px solid #353945;
          justify-content: space-around;
        }
      }
      .table_btn {
        i {
          margin-left: 5px;
        }
      }
    }
    .el-card {
      color: #fff;
      border: 1px solid rgba(13, 18, 28, 0.7);
      background-color: rgba(13, 18, 28, 0.7);
    }
    .nodata {
      text-align: center;
    }
  }
}

.time-value-area {
  height: 34px;
  line-height: 34px;
  @include set_theme_color(background-color, input-default-bg-color);
  @include set_theme_color(color, font-inactive-color);
  border-radius: 4px;
  // border: 1px solid #313841;
  border-image: initial;
  display: flex;
  margin-left: 10px;

  &.plan-date {
    cursor: pointer;
    padding: 0 10px;

    label {
      cursor: pointer;
    }

    .time-label {
      flex: 1;
      text-align: center;
      @include set_theme_color(color, font-default-color);

      &.placeholder-text {
        color: #757575;
      }
    }

    .split-label {
      margin: 0 10px;
    }
  }

  &.plan-type {
    padding: 0 10px;
    cursor: pointer;
    position: relative;

    label {
      cursor: pointer;
    }

    &.disabled {
      cursor: no-drop;

      label {
        cursor: no-drop;
      }
    }

    .placeholder-text {
      color: #757575;
    }

    .type-select {
      position: absolute;
      top: 30px;
      left: 0;
      width: 100%;
      overflow: hidden;
      height: 0;
      transition: all 0.3s;
      z-index: 101;

      .select-area {
        background-color: #fff;
        border-radius: 3px;
        border: 1px solid #cccccc;
        height: 100%;
        width: 100%;
      }

      .type-option {
        padding: 0 10px;

        &.choosed {
          background-color: #475892;
          color: #ffffff;
        }

        &:hover {
          background-color: #6673ac;
          color: #ffffff;
        }
      }

      &.expand {
        height: 56px;
      }
    }
  }

  input {
    outline: none;
    border: none;
    padding: 0 10px;
    line-height: 1;
    width: 100%;
  }
}
</style>
